module.exports = __webpack_public_path__ + "static/media/three.df652716.png";